import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import DisplayData from 'shared/display-data/display-data.component';
import { DESTINATION_TYPES } from 'tracker.constants';
import {
  DESTINATION_TYPE_BUTTON_ID,
  DESTINATION_TYPE_LABEL_TEXT
} from './destination-type-classification.constants';

export default function DestinationTypeClassification({
  destinationTypeData,
  onClick,
  hasDivider
}) {
  const destinationDataIsValid =
    destinationTypeData && destinationTypeData !== 'UNDEFINED';

  const destinationData = destinationDataIsValid
    ? DESTINATION_TYPES[destinationTypeData].LABEL
    : null;
  const destinationIcon = destinationDataIsValid
    ? DESTINATION_TYPES[destinationTypeData].VALUE
    : 'HOME';

  const buttonIcon = destinationDataIsValid ? icons.type.EDIT : icons.type.ADD;

  return (
    <DisplayData
      hasDivider={hasDivider}
      label={DESTINATION_TYPE_LABEL_TEXT}
      mainData={destinationData}
      icon={icons.type[destinationIcon]}
      actionButton={{
        icon: buttonIcon,
        click: onClick,
        dataTestid: DESTINATION_TYPE_BUTTON_ID
      }}
    />
  );
}

DestinationTypeClassification.displayName = 'DestinationTypeClassification';
DestinationTypeClassification.propTypes = {
  onClick: PropTypes.func.isRequired,
  destinationTypeData: PropTypes.string,
  hasDivider: PropTypes.bool
};
DestinationTypeClassification.defaultProps = {
  destinationTypeData: null,
  hasDivider: false
};
